import { ReactElement, useState } from 'react'
import {
  FlexWrapper,
  DropdownWrapper,
  EditableDropdown,
  Input,
  TableWrapper,
  TableHeader,
  PageWrapper
} from '../../../../components'
import strings from '../../../../locale/en'
import { testList, testStatus } from './const'
import Table from 'react-bootstrap/Table'
import { assignedTableHeader } from './const'
import { TableRow, DatePickerWrapper } from './subcomponents'
import DatePicker from 'react-datepicker'
import UserAction from '../../User/UserAction'
import { FormBackWrapper } from '../../User/subcomponents'

const NewlyAddedList = (): ReactElement => {
  const [startDate, setStartDate] = useState<any>(new Date())
  const {
    menu: {
      admin: {
        createTest: { selectTestType, selectStatus },
        selectDate
      }
    }
  } = strings

  return (
    <PageWrapper>
      <FlexWrapper noPadding>
        <DropdownWrapper>
          <EditableDropdown
            dropdownList={testList}
            placeholder={selectTestType}
            onBlur={() => { }}
            error={''}
            handleSelect={() => { }}
          />
        </DropdownWrapper>
        <DropdownWrapper>
          <EditableDropdown
            dropdownList={testStatus}
            placeholder={selectStatus}
            onBlur={() => { }}
            error={''}
            handleSelect={() => { }}
          />
        </DropdownWrapper>
        <DropdownWrapper>
          <DatePickerWrapper>
            <DatePicker
              selected={startDate}
              onSelect={(date) => setStartDate(date)}
              onChange={(date) => setStartDate(date)}
              placeholderText={selectDate}
              customInput={
                <Input
                  value={startDate}
                  inputType="text"
                  placeholder={selectDate}
                  onChange={(date) => setStartDate(date)}
                  suffix={['far', 'calendar']}
                />
              }
            />
          </DatePickerWrapper>
        </DropdownWrapper>
      </FlexWrapper>
      <FormBackWrapper>
        <TableWrapper>
          <Table size="sm" responsive="sm">
            <TableHeader>
              <TableRow>
                {assignedTableHeader?.map((header, index) => (
                  <th key={`test-listing-header-${index}`}>{header}</th>
                ))}
              </TableRow>
            </TableHeader>
            <tbody>
              <td>{'Test type'}</td>
              <td>{'Test name'}</td>
              <td>{'Test code'}</td>
              <td>{'04/12/2021'}</td>
              <td>{'Active'}</td>
              <td>
                <UserAction
                  handleUserDetail={() => { }}
                  handleNewUserSelect={() => { }}
                  handleDelete={() => { }}
                  handleAssign={() => { }}
                />
              </td>
            </tbody>
          </Table>
        </TableWrapper>
      </FormBackWrapper>
    </PageWrapper>
  )
}

export default NewlyAddedList
